// Куда открывать ссылку из ленты (план 26.08.2026, ступень 3): в новой вкладке
// — сайт клиента, уводить посетителя со страницы посреди диалога нельзя; или
// в этом окне — консультант платформы на своём сайте: виджет там на каждой
// странице, история подхватится по ключу посетителя. Чистый модуль без DOM —
// правило тестируется в изоляции (navigation.test.mjs).
export interface NavigationContext {
  /** page_target из конфига сервера: 'self' — консультант платформы,
   *  'frame' — холодное демо (сайт цели живёт в рамке нашей же страницы). */
  pageTarget?: string;
  /** data-launcher виджета: без пузыря (чат поддержки в кабинете) переход в
   *  этом окне увёл бы владельца из кабинета — только новая вкладка. */
  launcher?: string;
  /** window.location.origin страницы, где живёт виджет. */
  origin: string;
}

/** Переходить в этом окне: разрешено сервером, есть пузырь, адрес — на том же
 *  сайте (чужой домен всегда во вкладку: там нашего виджета нет). */
export function opensInPlace(url: string, context: NavigationContext): boolean {
  if (context.pageTarget !== 'self' || context.launcher === 'none') return false;
  try {
    return new URL(url, context.origin).origin === context.origin;
  } catch {
    return false;
  }
}

/** Открывать в РАМКЕ демо: холодное демо показывает сайт цели документом
 *  внутри нашей страницы, поэтому новая вкладка уносит владельца из демо
 *  вместе с чатом, а переход «в этом окне» снёс бы саму страницу демо.
 *  Ссылку ведём в ту же рамку — как ведут собственные ссылки сайта внутри неё. */
export function opensInFrame(context: NavigationContext): boolean {
  return context.pageTarget === 'frame' && context.launcher !== 'none';
}
